import React, { useEffect, useState } from "react";
import { getCommissionRecordsByUserId } from "../../../slices/individuals/thunk";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import FooterPagination from "../../Pagination/FooterPagination";
import { Card, CardBody, CardHeader, Table } from "reactstrap";
import UserStatusBadge from "../../Badges/UserStatusBadge";
import moment from "moment";
import Loading from "../../Loading";

const CommissionsIndividualsTable = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();

  const [commissions, setCommissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const fetchCommissionsRecords = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        getCommissionRecordsByUserId({ userId: id, page: currentPage })
      );
      const res = response.payload;

      console.log(response);

      if (res && !res.error) {
        setCommissions(res.data);
        setTotalPages(res.page);
        totalItems(res.total);
        setPageSize(response.payload.pageSize);
      }

      // setCommissions(data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleViewProfile = (id) => {
    navigate(`/commissions/commissionDetail/${id}`);
  };

  useEffect(() => {
    fetchCommissionsRecords();
  }, [id, currentPage]);

  const formatDate = (dateInput, subtractDay = false) => {
    if (!dateInput) {
      return null;
    }

    let date;
    if (typeof dateInput === "number") {
      date = moment.utc(dateInput * 1000);
    } else if (typeof dateInput === "string") {
      date = moment.utc(dateInput);
    } else {
      return null;
    }
    if (subtractDay) {
      date.subtract(1, "days");
    }
    return date.format("DD/MM/YYYY");
  };

  const parseComimssion = (commission) => `$${(commission / 100).toFixed(2)}`;

  return (
    <>

      <Card>
        <CardHeader>
          <h4 className="title">Commissions</h4>
        </CardHeader>

        <CardBody>
          <div className="table-container position-relative">
            {loading && <Loading />}

            <div className="live-preview">
              <div className="table-responsive ">
                <Table className="table table-hover border table-centered align-middle table-nowrap mb-0">
                  <thead className="bg" style={{ background: "var(--thead-bg)" }}>
                    <tr>
                      <th scope="col">Date</th>
                      <th scope="col">Description</th>
                      <th scope="col">Status</th>
                      <th scope="col">Total</th>

                      {/* <th scope="col" className="text-center">
              Manage
            </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {/* {isNotSearchResult && (
            <tr>
              <td className="text-center" colSpan="12">
                No search results for "{searchParam}"
              </td>
            </tr>
          )} */}

                    {!commissions.length ? (
                      <tr>
                        <td className="text-center" colSpan="12">
                          You have no Individuals yet.
                        </td>
                      </tr>
                    ) : (
                      commissions.map((commission, index) => {
                        //   const statusBadgeClass =
                        //     individual.status === "active"
                        //       ? "success"
                        //       : individual.status === INDIVIDUAL_STATUS.INVITED
                        //       ? "info"
                        //       : "danger";

                        return (
                          <tr
                            key={index}
                          // className="cursor-pointer"
                          // onClick={() => handleViewProfile(commission.id)}
                          >
                            <td>{moment(commission.date).format('MM/DD/YYYY')}</td>

                            <td>{commission.description}</td>

                            <td>
                              <UserStatusBadge
                                status={
                                  commission.processed === true
                                    ? "Processed"
                                    : "Pending"
                                }
                                color={
                                  commission.processed === true
                                    ? "success"
                                    : "warning"
                                }
                              />
                            </td>
                            <td>{parseComimssion(commission.totalAmount)}</td>
                            {/* <td className="text-center">
                    <ButtonGroup onClick={(e) => e.stopPropagation()}>
                      <UncontrolledDropdown className="dropdown d-inline-block">
                        <DropdownToggle
                          tag="button"
                          className="btn btn-soft-primary  btn-sm"
                        >
                          <i className="ri-more-fill align-middle"></i>
                        </DropdownToggle>
                        {renderDropdownMenu(individual)}
                      </UncontrolledDropdown>
                    </ButtonGroup>
                  </td> */}
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                  {totalItems > 0 && (
                    <tfoot>
                      <FooterPagination
                        itemsCount={commissions.length}
                        totalPages={totalPages}
                        totalItems={totalItems}
                        currentPage={currentPage}
                        onChangePage={handleChangePage}
                        onChangePageSize={onChangePageSize}
                      />
                    </tfoot>
                  )}
                </Table>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default CommissionsIndividualsTable;
